import { Injectable, inject } from '@angular/core';
import { DevicesService } from '@era/locations-sdk';
import { safeMap } from '@era/stores';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { DeviceSyncStatusApiActions, DeviceSyncStatusResolverActions } from './device-sync-status.actions';

@Injectable()
export class DeviceSyncStatusEffects {
  private readonly actions$ = inject(Actions);
  private readonly api = inject(DevicesService);

  mdmStatussesRequestedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DeviceSyncStatusResolverActions.syncStatusesRequested),
      mergeMap((action) =>
        safeMap(
          this.api.getDeviceSyncStatus({
            brandId: action.brandId ?? undefined,
            locationId: action.locationId ?? undefined,
            roomId: undefined,
            frontDeskId: undefined,
            housekeepingId: undefined,
            barId: undefined,
            staffId: undefined,
            kioskId: undefined,
          }),
          (list) => DeviceSyncStatusApiActions.syncStatusesLoaded({ statuses: list }),
          (error) => DeviceSyncStatusApiActions.syncStatusesLoadedError({ error })
        )
      )
    );
  });
}
